import format from 'date-fns/format';
import isSameYear from 'date-fns/isSameYear';
import parseISO from 'date-fns/parseISO';

export const getFormattedDate = (date: string): string => {
  const today = new Date();
  return isSameYear(parseISO(date), today) ? format(parseISO(date), 'dd MMM') : format(parseISO(date), 'dd MMM yyyy');
};
